import { DynamicIcon } from 'phosphor-icons/react';

export const ProductBreadcrumbs = ({
  path,
}: {
  path: {
    name: string;
    slug: string;
  }[];
}) => {
  return (
    <ul
      className="mb-4 flex flex-wrap items-center"
      data-test="product-breadcrumbs-list"
      aria-label="Breadcrumb"
    >
      {path.map((item, index) => {
        const isLastItem = index === path.length - 1;
        const base =
          'self-stretch p-1 text-xs font-normal uppercase leading-[20px] tracking-[1.2px] transition-colors';
        const text = isLastItem ? 'text-grey-900' : 'text-grey-600';
        return (
          <li className="flex items-center" key={item.slug}>
            {isLastItem ? (
              <span className={`${base} ${text}`} aria-current="page">
                {item.name}
              </span>
            ) : (
              <a
                href={
                  item.slug === '/' ? '/' : `/${item.slug.replace(/^\/+/, '')}`
                }
                className={`${base} ${text}`}
              >
                {item.name}
              </a>
            )}
            {!isLastItem && (
              <DynamicIcon
                className="ml-[8px] mr-[4px] fill-grey-400"
                height={16}
                width={16}
                iconName="CaretRight"
                aria-hidden="true"
              />
            )}
          </li>
        );
      })}
    </ul>
  );
};
